import clsx from "clsx";
import { Filters } from "../../../../../lib/filters";
import { CompaniesHorizontalFilters } from "../../../../../lib/filters/accordion/horizontalFiltersCompany";
import { ContactDTO, ContactType, FindAllContactsFilters, FindContactsTargetResponse } from "../../../../../lib/filters/dto";
import { useAppSelector } from "../../../../../lib/redux/hooks";
import { ProjectDTO } from "../../../../projects/dto";
import { ContactsCounterDTO } from "../../../contacts/dto";
import { TargetListDTO } from "../../../dto";
import { TargetCompaniesList } from "./list";
import { EmailsMessagesDTO, FindAllCustomMailsResponseDTO } from "../../../../projects/mails/dto";
import { PersonDTO } from "../../../../database/people/dto";

interface Props {
  toActivate: number
  showPopup: boolean
  setShowPopup: (action: boolean) => void
  selectedIds: { contactId: string, companyId: string }[]
  setSelectedIds: (action: { contactId: string, companyId: string }[]) => void
  filters: FindAllContactsFilters
  setFilters: (action: Partial<FindAllContactsFilters>) => void
  setPage: (action: number) => void
  resetFilters: () => void
  contacts: {
    total: number
    page: number
    perPage: number
    prev: boolean
    next: boolean
    totalPage: number
    data: { company: ContactDTO<ContactType.COMPANY>, employees: PersonDTO[] }[]
  }
  counters: ContactsCounterDTO
  targetList: TargetListDTO
  project: ProjectDTO
  isLoadingEmailsHistory: boolean
  emailsHistory: { messages: EmailsMessagesDTO[] }
  templates: FindAllCustomMailsResponseDTO
}

export function TargetListCompaniesList(props: Props) {
  const { selectedIds, setSelectedIds, setShowPopup, showPopup, targetList, toActivate, setFilters, setPage, filters, resetFilters, contacts, counters, project, isLoadingEmailsHistory, emailsHistory, templates } = props
  const databaseState = useAppSelector((state) => state.database);

  return (
    <div className="flex w-full h-full rounded-t-2xl max-h-full transition-all duration-300">
      <div
        className={clsx("transition-all duration-300 w-[20%] flex-shrink-0", {
          block: databaseState.filtersActive,
          hidden: !databaseState.filtersActive,
        })}
      >
        <Filters
          section="target"
          isInTargetList={true}
          contactType={ContactType.COMPANY}
          resetFilters={() => resetFilters()}
          filters={filters}
          updateFilters={arg => setFilters(arg)}
        />
      </div>
      <div
        className={clsx("transition-all h-full max-h-full duration-300", {
          "w-full": !databaseState.filtersActive,
          "w-4/5": databaseState.filtersActive,
        })}
      >
        <CompaniesHorizontalFilters
          onChangeFilters={(arg) => setFilters(arg)}
          filters={filters}
          toActivate={toActivate}
          isInTargetList={true}
        />
        <TargetCompaniesList
          section="target"
          templates={templates}
          isLoadingEmailsHistory={isLoadingEmailsHistory}
          emailsHistory={emailsHistory}
          project={project}
          targetList={targetList}
          counters={counters}
          contacts={contacts}
          selectedIds={selectedIds}
          setSelectedIds={arg => setSelectedIds(arg)}
          setShowPopup={arg => setShowPopup(arg)}
          showPopup={showPopup}
          filters={filters}
          setFilters={function (action: Partial<FindAllContactsFilters>): void {
            setFilters(action);
          }}
          setPage={function (action: number): void {
            setPage(action);
          }}
          resetFilters={function (): void {
            resetFilters()
          }}
        />
      </div>
    </div>
  );
}
